/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillSyncEntities} from '../api'

export const useMutationBackfillSyncEntities = createReactQueryMutationHook('backfillSyncEntities', backfillSyncEntities)
